// NOTE: Changing this value should be considered a version breaking change!!!
export const IFRAME_ID = 'connectIframe';
export const STYLES_ID = 'connectStyles';
export const PLATFORM_IFRAME = 'iframe';
export const PLATFORM_POPUP = 'web';
export const CONNECT_SDK_VERSION = '2.3.0';
export const CONNECT_SDK_BUILD_SOURCE = 'NPM';

// NOTE: oauth popup window dimensions
export const POPUP_WIDTH = 600;
export const POPUP_HEIGHT = 600;

// NOTE: connect popup window dimensions
export const CONNECT_POPUP_WIDTH = 520;
export const CONNECT_POPUP_HEIGHT = 720;

// NOTE: available events
export const ACK_EVENT = 'ack';
export const CANCEL_EVENT = 'cancel';
export const URL_EVENT = 'url';
export const DONE_EVENT = 'done';
export const ERROR_EVENT = 'error';
export const PING_EVENT = 'ping';
export const WINDOW_EVENT = 'window';
export const ROUTE_EVENT = 'route';
export const USER_EVENT = 'user';
export const CLOSE_POPUP_EVENT = 'closePopup';
